/**
 * Etapa 1 - Dados: identificacao da empresa e contato principal.
 *
 * CNPJ e telefone sao guardados so com digitos; a mascara e aplicada no
 * `value` do campo a cada render. Colar "12.345.678/0001-90" funciona igual a
 * digitar os numeros, porque a limpeza acontece no `onChange`.
 */

import { Field, Fieldset, Input } from '../../../../components/ui';
import { mascararCnpj, mascararTelefone, somenteDigitos } from '../../assistente';
import { erroDe, type EtapaProps } from './props';

export function EtapaDados(props: EtapaProps): JSX.Element {
  const { form, onChange } = props;
  return (
    <div className="flex flex-col gap-4">
      <Fieldset legend="Empresa" description="Como a empresa aparece no painel e nas mensagens da régua.">
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="Nome da empresa" required error={erroDe(props, 'nome')} className="sm:col-span-2">
            {({ id, describedBy, invalid }) => (
              <Input id={id} aria-describedby={describedBy} aria-invalid={invalid} value={form.nome} onChange={(e) => onChange({ nome: e.target.value })} autoComplete="organization" placeholder="Ex.: Escola Fluente" />
            )}
          </Field>
          <Field label="Segmento" required hint="Uma linha: cursos online, assinatura de treinos, loja de suplementos..." error={erroDe(props, 'segmento')}>
            {({ id, describedBy, invalid }) => <Input id={id} aria-describedby={describedBy} aria-invalid={invalid} value={form.segmento} onChange={(e) => onChange({ segmento: e.target.value })} autoComplete="off" />}
          </Field>
          <Field label="CNPJ" hint="Opcional na prévia. Só números; a máscara é automática." error={erroDe(props, 'cnpj')}>
            {({ id, describedBy, invalid }) => (
              <Input
                id={id}
                aria-describedby={describedBy}
                aria-invalid={invalid}
                inputMode="numeric"
                value={mascararCnpj(form.cnpj)}
                onChange={(e) => onChange({ cnpj: somenteDigitos(e.target.value).slice(0, 14) })}
                placeholder="00.000.000/0000-00"
                autoComplete="off"
              />
            )}
          </Field>
          <Field label="Site" hint="Opcional. Ex.: loja.exemplo" error={erroDe(props, 'site')} className="sm:col-span-2">
            {({ id, describedBy, invalid }) => <Input id={id} type="url" inputMode="url" aria-describedby={describedBy} aria-invalid={invalid} value={form.site} onChange={(e) => onChange({ site: e.target.value })} autoComplete="url" />}
          </Field>
        </div>
      </Fieldset>

      <Fieldset legend="Contato principal" description="Quem responde pela empresa junto ao Converte Fácil. Pode ser o mesmo que o dono da conta (etapa 7).">
        <div className="grid gap-4 sm:grid-cols-3">
          <Field label="Nome" required error={erroDe(props, 'contatoNome')}>
            {({ id, describedBy, invalid }) => <Input id={id} aria-describedby={describedBy} aria-invalid={invalid} value={form.contatoNome} onChange={(e) => onChange({ contatoNome: e.target.value })} autoComplete="name" />}
          </Field>
          <Field label="E-mail" required error={erroDe(props, 'contatoEmail')}>
            {({ id, describedBy, invalid }) => (
              <Input id={id} type="email" inputMode="email" aria-describedby={describedBy} aria-invalid={invalid} value={form.contatoEmail} onChange={(e) => onChange({ contatoEmail: e.target.value })} autoComplete="email" />
            )}
          </Field>
          <Field label="Telefone" hint="Com DDD. Opcional." error={erroDe(props, 'contatoTelefone')}>
            {({ id, describedBy, invalid }) => (
              <Input
                id={id}
                type="tel"
                inputMode="tel"
                aria-describedby={describedBy}
                aria-invalid={invalid}
                value={mascararTelefone(form.contatoTelefone)}
                onChange={(e) => onChange({ contatoTelefone: somenteDigitos(e.target.value).slice(0, 11) })}
                placeholder="(11) 99999-9999"
                autoComplete="tel-national"
              />
            )}
          </Field>
        </div>
      </Fieldset>
    </div>
  );
}
